export const EventType = {
	PATIENT_VISIT_ASSIGNED: "niramaya.patientvisit.assigned",
	PATIENT_VISIT_ADDED: "niramaya.patientvisit.added",
	PATIENT_VISIT_ACCEPTED: "niramaya.patientvisit.accepted",
	PATIENT_VISIT_UPDATED: "niramaya.patientvisit.updated",
	PATIENT_VISIT_REJECTED: "niramaya.patientvisit.rejected",
	PATIENT_VISIT_RE_ASSIGN: "niramaya.patientvisit.assigned",
	PATIENT_FORMS_SUBMITTED: "niramaya.forms.submitted",
	PATIENT_FORMS_UPDATED: "niramaya.forms.updated",
	OPPORTUNITY_ACCEPTED: "niramaya.opportunity.accepted",
	OPPORTUNITY_REJECTED: "niramaya.opportunity.rejected",
	DELIVERY_ADDED: "niramaya.delivery.added",
	DELIVERY_UPDATED: "niramaya.delivery.updated",
	CAREPLAN_ADDED: "niramaya.care_plan.added",
	PATIENT_DETAILS_UPDATED: "niramaya.patient.updated",
	PATIENT_CREATED: "niramaya.forms.patientcreated",
	PREFERENCE_TAG_CREATED: "niramaya.taggingsystem.tag.create",
	PREFERENCE_TAG_UPDATE: "niramaya.taggingsystem.tag.update",
	PREFERENCE_TAG_DELETED: "niramaya.taggingsystem.tag.delete",
	ENTITY_TAG_CREATED: "niramaya.taggingsystem.entitytag.create",
	ENTITY_TAG_UPDATED: "niramaya.taggingsystem.entitytag.update",
	ENTITY_TAG_DELETED: "niramaya.taggingsystem.entitytag.delete",
	CREATE_TEAM_MEMBER: "niramaya.teammember.add",
	GROUP_ADDED: "niramaya.group.added",
	GROUP_UPDATED: "niramaya.group.updated",
	GROUP_MEMBERSHIP_UPDATED: "niramaya.group.membership.updated",
	GROUP_MEMBERSHIP_DELETED: "niramaya.group.membership.deleted",
	ADD_WORKFORCE: "niramaya.workforce.add",
	add_patient: "niramaya.patient.add",
	NIRAMAYA_INVITATION_ACCEPT: "niramaya.invitation.accept",
	API_RESPONSE_RECEIVED: "niramaya.api.response.received",
	NIRAMAYA_SCHEDULE_USER_DEMO: "niramaya.schedule.user.demo",
	PATIENT_TEAM_MEMBER_RESPONSE: "niramaya.patient.carecircle.teammember.response",
	PATIENT_DATA_UPDATED: "niramaya.patient.data.updated",
	WORKFORCE_DATA_UPDATED: "niramaya.workforce.data.updated",
	WORKFORCE_PIN_RESET: "niramaya.workforce.pin.reset",
	WORKFORCE_INVITED: "niramaya.workforce.invited",
	REPORT_DATA_UPADTED: "niramaya.report.data.updated",
	REPORT_DELETED: "niramaya.report.deleted",
	REPORT_SAVE_AS_NEW: "niramaya.report.save.as.new",
	VISIT_FORM_APPROVED: "niramaya.visit.form.approved",
	VISIT_FORM_REJECTED: "niramaya.visit.form.rejected",
	CAREPLAN_ACCEPTED: "niramaya.careplan.accepted",
	CAREPLAN_REJECTED: "niramaya.careplan.rejected",
};
